export interface TenantConfigEntity {
    url: string;
    name: string;
    bffUrl: string;
    allowTodoList: boolean;
    politiqueConfidentialite: string;
  }